export const apiUrls = {
  token: {
    tokens: '/tokens',
    token: '/token',
    apr: '/tokens/apr'
  },
  statistics: {
    transactions: '/statistics/transactions',
    distribution: '/statistics/distribution'
  },
  v1: {
    stake: '/v1/stake',
    statistics: {
      sold: '/v1/statistics/sold',
      rate: '/v1/statistics/rate',
      buyback: '/v1/statistics/buyback',
      spent: '/v1/statistics/spent',
      pressure: '/v1/statistics/pressure',
      holder: '/v1/statistics/holder',
      dex: '/v1/statistics/dex'
    },
    activity: '/v1/activity',
    user: '/v1/user'
  },
  v2: {
    activity: '/v2/activity'
  },
  crafting: {
    buildings: '/crafting/buildings',
    inQueue: '/crafting/recipes/in-queue'
  },
  streetMerchant: '/street-merchant/activity',
  user: { user: '/user', exists: '/user/exists', usersStats: '/user/users-stats' },
  seasons: {
    config: (seasonId: number) => `/seasons/${seasonId}/config`,
    positionsRewards: (seasonId: number) => `/seasons/${seasonId}/positions-rewards`,
    userScores: (seasonId: number) => `/seasons/${seasonId}/user-scores`
  },
  jackpot: {
    userScores: (seasonYear: number) => `/jackpot/${seasonYear}/user-scores`,
    positionsRewards: (seasonYear: number) => `/jackpot/${seasonYear}/positions-rewards`
  },
  flipCoinGame: {
    tokenConfig: '/flip-coin-game/token-config',
    confirmGame: (gameId: number) => `/flip-coin-game/${gameId}/confirm`,
    initGame: '/flip-coin-game/initial',
    games: '/flip-coin-game/games',
    game: (gameId: number) => `/flip-coin-game/games/${gameId}`
  },
  pusher: {
    stats: '/coin-pusher-game/stats',
    usersStats: '/coin-pusher-game/users-stats',
    config: '/coin-pusher-game/config',
    result: '/coin-pusher-game/result'
  },
  bundles: '/bundles/list',
  dex: '/internal-dex/pairs',
  ws: {
    streetMerchant: '/ws/street-merchant/config',
    craftingActivity: (userAddress: string) => `/ws/crafting/users-activity/${userAddress}`
  }
};
